<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2024-04-19 13:23:56
 * @LastEditTime : 2025-11-04 14:28:50
 * @LastEditors  : yangxr
 * @Description  : 累计车辆弹窗
 * @FilePath     : \icps_fb\src\views\platform\ICPS\smart\schedul\components\carDetail.vue
-->
<template>
  <el-dialog :visible="visible" title="补录" width="80%" @close="onClose" @open="onOpen">
    <span slot="title" class="dialog-title">物流运输</span>
    <div class="carDetail">
      <div v-if="carType != 3" class="FZYtitle">
        <span>工程名称：{{ formTop.engineeringName }}</span>
        <span style="margin-left:30px">浇筑部位：{{ formTop.structuralParts || formTop.pourPart}}</span>
        <span style="margin-left:30px">订单号：{{ formTop.orderNo || formTop.planCode}}</span>
        <span style="margin-left:30px">产品名称：{{ formTop.productName || formTop.product}}</span>
        <span style="margin-left:30px">搜索:</span><el-input v-model="filterCarNo" style="width: 200px"
          placeholder="请输入车牌号/运输号" clearable />
      </div>
      <div v-if="carType == 3" class="FZYtitle">
        <span style="margin-left:30px">搜索:</span><el-input v-model="filterCarNo" style="width: 200px"
          placeholder="请输入车牌号/运输号" clearable />
        <span style="margin-left:30px">生产时间:</span>
        <el-date-picker v-model="productTime" style="width: 190px" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择日期时间" @change="get_dispatch_logistics_page()"> </el-date-picker>

      </div>
      <div v-if="carType != 3 && !isLook" style="margin-bottom: 10px">
        <el-link class="table_link" :underline="false" @click="look1Type1Fun">小票补录</el-link>
      </div>
      <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border
        style="width: 100%" height="600" :data="filteredData" tooltip-effect="dark" :row-class-name="tableRowClassName">
        <template v-for="(item, index2) in tableB">
          <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :width="item.width"
            :fixed="item.label == '异常管理' || item.label == '操作通知' || item.label == '操作' || item.label == '打印' || item.label == '签收' || item.label == '物流' ? 'right' : false"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <div v-if="item.label == '状态'">
                <div v-if="scope.row.dataStatus == 1">检验中</div>
                <div v-if="scope.row.dataStatus == 2">运输中</div>
                <div v-if="scope.row.dataStatus == 3">浇筑中</div>
                <div v-if="scope.row.dataStatus == 4">已签收</div>
                <div v-if="scope.row.dataStatus == 5">未确认</div>
                <div v-if="scope.row.dataStatus == 6">待签收</div>
                <div v-if="scope.row.dataStatus == 7">已拒绝</div>
                <div v-if="scope.row.dataStatus == 8">已取消</div>
                <div v-if="scope.row.dataStatus == 10" style="color: red">转场</div>
              </div>
              <div v-else-if="item.label == '容重'">
                {{ scope.row.mixProportion }}
              </div>
              <div v-else-if="item.label == '运输号'">
                <el-link class="table_link" :style="{ color: scope.row.dataStatus == 6 ? 'red' : '' }" :underline="false"
                  @click="lookFun(scope.row, 1)">{{ scope.row.code }}</el-link>
              </div>
              <div v-else-if="item.label == '异常管理'">
                <el-link class="table_link" :underline="false" :disabled="scope.row.dataStatus == 4"
                  @click="look5Fun(scope.row)">检测</el-link>
                <el-link :disabled="scope.row.dataStatus == 4" class="table_link" :underline="false"
                  @click="look4Fun(scope.row)">过磅核对</el-link>
                <el-link :disabled="scope.row.dataStatus == 4" class="table_link" :underline="false"
                  @click="look7Fun(scope.row)">物流异常</el-link>
              </div>
              <div v-else-if="item.label == '操作'" style="display: flex;">
                <el-popover v-if="!(scope.row.dataStatus == 8 || scope.row.dataStatus == 10)" :ref="`popover1-${scope.$index}`" placement="right" width="400" trigger="click">
                  <div style="margin-left: 20px">
                    <div><span>你确定要出场过磅吗?</span></div>
                    <div>
                      <span>是否补单:</span><el-radio-group v-model="supplementaryOrdersStatus">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                      </el-radio-group>
                    </div>
                    <span>补单仅用作无人值守异常任务关联，正常任务则为否。</span>
                    <span class="dialog-footer">
                      <el-button class="bottom_all" style="margin-left: 24px"
                        @click="addOutboundTask(scope.row.code, scope.$index)">确定</el-button>
                    </span>
                  </div>
                  <el-link slot="reference" class="table_link" :underline="false" :disabled="scope.row.dataStatus == 8 || scope.row.dataStatus == 10 || isLook"
                    @click.native="handleLinkClick()">出场过磅</el-link>
                </el-popover>
                <el-link v-else slot="reference" class="table_link" :underline="false" :disabled="scope.row.dataStatus == 8 || scope.row.dataStatus == 10 || isLook"
                    >出场过磅</el-link>
                <el-popover v-if="!(scope.row.dataStatus == 8 || scope.row.dataStatus == 10)" :ref="`popover2-${scope.$index}`" placement="right" width="400" trigger="click">
                  <div style="margin-left: 20px">
                    <div><span>你确定要回场过磅吗?</span></div>
                    <div>
                      <span>是否补单:</span><el-radio-group v-model="supplementaryOrdersStatus">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                      </el-radio-group>
                    </div>
                    <span>补单仅用作无人值守异常任务关联，正常任务则为否。</span>
                    <span class="dialog-footer">
                      <el-button class="bottom_all" style="margin-left: 24px"
                        @click="addInboundTask(scope.row.code, scope.$index)">确定</el-button>
                    </span>
                  </div>
                  <el-link slot="reference" class="table_link" :underline="false" :disabled="scope.row.dataStatus == 8 || scope.row.dataStatus == 10 || isLook"
                    @click.native="handleLinkClick()">回场过磅</el-link>
                </el-popover>
                <el-link v-else slot="reference" class="table_link" :underline="false" :disabled="scope.row.dataStatus == 8 || scope.row.dataStatus == 10 || isLook"
                    >回场过磅</el-link>
              </div>
              <div v-else-if="item.label == '打印'">
                <el-link slot="reference" class="table_link" :underline="false"
                  @click="(formData = scope.row), handlePrint(scope.row)">打印</el-link>
              </div>
              <div v-else-if="item.label == '签收'">
                <el-link slot="reference" class="table_link" :underline="false" :disabled="scope.row.dataStatus == 10 || isLook"
                  @click="lookFun(scope.row, 2)">操作</el-link>
              </div>
              <div v-else-if="item.label == '调整余斜量'">
                <el-input v-model="scope.row.adjustResidueNum" :disabled="scope.row.dataStatus == 4" style="width: 100%"
                  @change="adjustFun(scope.row, 'adjustResidueNum')"></el-input>
              </div>
              <div v-else-if="item.label == '调整签收量'">
                <el-input v-model="scope.row.adjustSignForNum" :disabled="scope.row.dataStatus == 4" style="width: 100%"
                  @change="adjustFun(scope.row, 'adjustSignForNum')"></el-input>
              </div>
              <div v-else-if="item.label == '客户小方量运输补差(方)'">
                <div>{{ scope.row.smallQuantitiesDelta }} (方)</div>
                <el-radio-group v-model="scope.row.isSmallQuantities" :disabled="scope.row.dataStatus == 4"
                  @change="set_small_quantities_deltaFun('isSmallQuantities', scope.row)">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是</el-radio>
                </el-radio-group>
              </div>
              <div v-else-if="item.label == '运输单位小方量补差(方)'">
                <div>{{ scope.row.smallDeltaTransport }} (方)</div>
                <el-radio-group v-model="scope.row.isSmallTransport" :disabled="scope.row.dataStatus == 4"
                  @change="set_small_quantities_deltaFun('isSmallTransport', scope.row)">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是</el-radio>
                </el-radio-group>
              </div>
              <div v-else-if="item.label == '客户余料'">
                <div v-if="scope.row.companyIsClout === 1">有余料</div>
                <div v-else-if="scope.row.companyIsClout === 0">无余料</div>
                <div v-else>-</div>
              </div>
              <div v-else-if="item.label == '内部余料'">
                <div v-if="scope.row.frontIsClout === 1">有余料</div>
                <div v-else-if="scope.row.frontIsClout == 0">无余料</div>
                <div v-else>-</div>
              </div>
              <div v-else-if="item.label == '运输数据来源'">
                <div v-if="scope.row.dataType == 1">{{ scope.row.productionSite }} (ERP)</div>
                <div v-if="scope.row.dataType == 2">小票补录</div>
                <div v-if="scope.row.dataType == 3">空票签收</div>
                <div v-if="scope.row.dataType == 4">外协数据</div>
                <div v-if="scope.row.dataType == 5">翻料处理</div>
                <div v-if="scope.row.dataType == 6">生产运输</div>
              </div>
              <div v-else-if="item.label == '运输签收小票'">
                <span>
                  <el-link v-if="scope.row.driverTicket" class="table_link" :underline="false"
                    @click="handleVideo(scope.row.driverTicket)">查看</el-link>
                  <span v-else>-</span>
                </span>
              </div>
              <div v-else-if="item.label == '车牌号'">
                <span>
                  <span v-if="scope.row.dataStatus == 2">
                    <el-link class="table_link" style="font-size:12px" :underline="false" @click="gpsMap(scope.row)">{{
                      scope.row.carNo }}</el-link>
                  </span>
                  <span v-else style="font-size:12px">{{ scope.row.carNo }}</span>
                </span>
              </div>
              <div v-else-if="item.label == '卸料视频审核状态'">
                <div v-if="scope.row.dataType != 3">
                  <div v-if="scope.row.videoAudit == 0">未审核</div>
                  <div v-else-if="scope.row.videoAudit == 1">合格</div>
                  <div v-else-if="scope.row.videoAudit == 2">不合格</div>
                </div>
              </div>
              <div v-else-if="item.label == '操作通知'">
                <el-checkbox v-model="scope.row.markWeighing" label="回场过磅" :true-label="1" :false-label="0"
                  :disabled="scope.row.markWeighing == 1 || scope.row.dataStatus == 4"
                  @click.native="look1Fun(scope.row, $event)"></el-checkbox>
                <el-checkbox v-model="scope.row.markSalesReturn" label="强制退货" :true-label="1" :false-label="0"
                  :disabled="scope.row.markSalesReturn == 1 || scope.row.dataStatus == 4"
                  @click.native="look2Fun(scope.row)"></el-checkbox>
              </div>
              <div v-else-if="item.label == '高度/臂长(米)'">
                <div v-if="scope.row.detList.length == 1">
                  {{ scope.row.detList[0].height }}
                </div>
                <div v-else-if="scope.row.detList.length > 1">
                  <div v-for="item in scope.row.detList" :key="item.id" style="border-bottom: 1px solid #ebeef5">
                    {{ item.height }}
                  </div>
                </div>
              </div>
              <div v-else-if="item.label == '浇筑量(方)'">
                <div v-if="scope.row.detList.length == 1">
                  {{ scope.row.detList[0].num }}
                </div>
                <div v-else-if="scope.row.detList.length > 1">
                  <div v-for="item in scope.row.detList" :key="item.id" style="border-bottom: 1px solid #ebeef5">
                    {{ item.num }}
                  </div>
                </div>
              </div>
              <div v-else-if="item.label == '泵送时间'">
                <div v-if="scope.row.detList.length == 1">
                  {{ scope.row.detList[0].createTime }}
                </div>
                <div v-else-if="scope.row.detList.length > 1">
                  <div v-for="item in scope.row.detList" :key="item.id" style="border-bottom: 1px solid #ebeef5">
                    {{ item.createTime }}
                  </div>
                </div>
              </div>
              <div v-else-if="item.label == '泵管使用'">
                <!-- <div v-if="scope.row.detList.length == 1"> -->
                <el-radio-group v-if="scope.row.detList.length > 0" v-model="scope.row.detList[0].pumpLineUse"
                  :disabled="scope.row.dataStatus == 4"
                  @change="update_pump_line_useFun(scope.row.detList[0], scope.row.detList[0].pumpLineUse)">
                  <el-radio :label="1">内部泵管</el-radio>
                  <el-radio :label="2">外部泵管</el-radio>
                </el-radio-group>
              </div>
              <div v-else-if="item.label == '签收类型'">
                <span v-if="scope.row.dataStatus == 4">{{ scope.row[item.prop] == 0 ? "自动签收" : "手动签收" }}</span>
              </div>
              <div v-else-if="item.label == '后场手写签名'">
                <el-link v-if="scope.row.chiefSignUrl" class="table_link" :underline="false"
                  @click="signLook(scope.row, 2)">查看</el-link>
              </div>
              <div v-else-if="item.label == '离场类型'">
                <span>{{ scope.row[item.prop] == 1 ? "正常离场" : "补录离场" }}</span>
              </div>
              <div v-else-if="item.label == '工地重车过磅照片'">
                <span>
                  <el-link v-if="scope.row.reconditionUrl" class="table_link" :underline="false"
                    @click="handleVideo(scope.row.reconditionUrl)">查看</el-link>
                  <span v-else>-</span>
                </span>
              </div>
              <div v-else-if="item.label == '工地轻车过磅照片'">
                <span>
                  <el-link v-if="scope.row.emptyUrl" class="table_link" :underline="false"
                    @click="handleVideo(scope.row.emptyUrl)">查看</el-link>
                  <span v-else>-</span>
                </span>
              </div>
              <div v-else-if="item.label == '照片视频'">
                <span>
                  <el-link class="table_link" :underline="false" @click="imgVideo(scope.row)">查看</el-link>
                </span>
              </div>
              <span v-else class="ellipsis-text">{{ scope.row[item.prop] }}</span>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="bottom_all_two" @click="onClose">关 闭</el-button>
    </span>
    <!-- 小票补录 -->
    <el-dialog v-dialogDrag :visible.sync="look1Type1" append-to-body width="900px">
      <span slot="title" class="dialog-title">小票补录</span>
      <div class="dialoginfo">
        <el-form ref="submit1_1" :rules="rules1" :inline="true" :model="formData1" label-width="130px">
          <el-form-item prop="carNo" label="车牌号">
            <el-input v-model="formData1.carNo" :rows="5" resize="none" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="站点">
            <span>{{ formData1.productionSite }}</span>
          </el-form-item>
          <el-form-item prop="proLine" label="生产线">
            <el-select ref="queueUpLineGroup" v-model="formData1.proLine" style="width: 215px" placeholder="请选择"
              filterable @change="
                $nextTick(() => {
                  formData1.proLineName = $refs.queueUpLineGroup.selectedLabel;
                })
                ">
              <el-option v-for="item in lineList" :key="item.code" :label="item.name" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="proTime" label="生产时间">
            <el-date-picker v-model="formData1.proTime" style="width: 215px" type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择"></el-date-picker>
          </el-form-item>
          <!-- <el-form-item prop="proNum" label="生产量(方)">
            <el-input v-model="formData1.proNum" :rows="5" resize="none" placeholder="请输入" clearable type="Number"></el-input>
          </el-form-item> -->
          <el-form-item prop="faceValue" label="票面量(方)">
            <el-input v-model="formData1.faceValue" :rows="5" resize="none" placeholder="请输入" clearable
              type="Number"></el-input>
          </el-form-item>
          <el-form-item prop="productName" label="产品名称">
            {{ formTop.productName || formTop.product}}
          </el-form-item>
          <!-- <el-form-item prop="transportDistance" label="运输距离" :rules="[{ required: true, message: '请输入运输距离', trigger: 'blur' }]">
            <el-input v-model="formData1.transportDistance" :rows="5" resize="none" placeholder="请输入" clearable type="Number"></el-input>
          </el-form-item> -->
          <el-form-item>
            <span slot="label">附件</span>
            <FileComponent fileCode="engineeringNotesFile" :files="listFilesa" @deleteFile="deleteFile"
              @uplodeSuccess="uplodeSuccess" />
          </el-form-item>
          <el-form-item v-if="carType != 2" prop="productName" label="特殊产品">
            <el-select ref="productName" v-model="formData1.productName" style="width: 215px" placeholder="请选择"
              filterable>
              <el-option v-for="item in productList" :key="item.productName" :label="item.productName"
                :value="item.productName"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="look1Type1 = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="submit1_1()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 物流详情 -->
    <el-dialog v-dialogDrag :visible.sync="lookType" width="1300px" :close-on-click-modal="false" append-to-body>
      <span slot="title" class="dialog-title">运输信息</span>
      <div class="dialoginfo j_FZYinfo">
        <div :style="{
          background: '#000',
          height: '5px',
          width: '10cm',
        }"></div>
        <el-form ref="submit1_1" :rules="rules1" :inline="true" :model="formData" label-width="130px">
          <el-form-item label="运输号：">
            <span>{{ formData.code }}</span>
          </el-form-item>
          <el-form-item label="车牌号：">
            <span>{{ formData.carNo }}</span>
          </el-form-item>
          <el-form-item label="生产时间：">
            <span>{{ formData.proTime }}</span>
          </el-form-item>
          <el-form-item label="生产量(方)：">
            <span>{{ formData.proNum }}</span>
          </el-form-item>
          <el-form-item label="富余量(方)：">
            <span>{{ formData.residueNum }}</span>
          </el-form-item>
          <el-form-item label="损耗量(方)：">
            <span>{{ formData.lossNum }}</span>
          </el-form-item>
          <el-form-item label="转入量(方)：">
            <span>{{ formData.shiftTo }}</span>
          </el-form-item>
          <el-form-item label="票面量(方)：">
            <span>{{ formData.faceValue }}</span>
          </el-form-item>
          <el-form-item label="生产站：">
            <span>{{ formData.productionSite }}</span>
          </el-form-item>
          <el-form-item label="生产线：">
            <span>{{ formData.proLine }}</span>
          </el-form-item>
          <el-form-item label="容重：">
            <span>{{ formData.mixProportion }}</span>
          </el-form-item>
          <el-form-item label="异常调整量(方)：">
            <span>{{ formData.adjustNum }}</span>
          </el-form-item>
          <el-form-item label="过磅余料量(方)：">
            <el-input v-model="formData.residueNum" disabled style="width: 120px"></el-input>
          </el-form-item>
          <el-form-item label="客户余料量(方)：">
            <el-input v-model="formData.customerResidueNum" disabled style="width: 120px"></el-input>
          </el-form-item>
          <el-form-item label="签收量(方)：">
            <el-input v-model="formData.signForNum" disabled style="width: 120px"></el-input>
          </el-form-item>
          <el-form-item label="运输距离(千米)：">
            <el-input v-model="formData.transportDistance" :disabled="formData.dataStatus == 4" style="width: 120px"
              onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
              @input="formData.transportDistance = $regExp.checkNum(formData.transportDistance)"
              @blur="formData.transportDistance = $regExp.blurCheckNum(formData.transportDistance)"></el-input>
          </el-form-item>
          <el-form-item label="客户小方量运输补差(方)：" style="width: 360px" label-width="180px">
            <span>{{ formData.smallQuantitiesDelta }}</span>
            <el-radio-group v-model="formData.isSmallQuantities" style="margin-left: 20px"
              :disabled="formData.dataStatus == 4">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="运输单位小方量补差(方)：" style="width: 360px" label-width="180px">
            <span>{{ formData.smallDeltaTransport }}</span>
            <el-radio-group v-model="formData.isSmallTransport" style="margin-left: 20px"
              :disabled="formData.dataStatus == 4">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="状态：">
            <span v-if="formData.dataStatus == 1">检验中</span>
            <span v-if="formData.dataStatus == 2">运输中</span>
            <span v-if="formData.dataStatus == 3">浇筑中</span>
            <span v-if="formData.dataStatus == 4">已签收</span>
            <span v-if="formData.dataStatus == 5">未确认</span>
            <span v-if="formData.dataStatus == 6">待签收</span>
            <span v-if="formData.dataStatus == 7">已拒绝</span>
          </el-form-item>
          <div>
            <div v-if="formData.dataStatus != 4" style="padding-bottom: 10px">
              <el-button size="mini" class="bottom_all" style="margin-left: 0" @click="addDetList()">
                <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                添加
              </el-button>
            </div>
            <el-table ref="formDataTable" :header-cell-style="{ background: '#f3f6f9' }"
              :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="formData.detList"
              tooltip-effect="dark" :row-class-name="className">
              <el-table-column label="泵类型" align="center" width="120">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.pouringWayId" :disabled="formData.dataStatus == 4" placeholder="请选择"
                    style="width: 100%" @change="changeItem2(scope.row)">
                    <el-option v-for="(item, index) in pumpTypeList" :key="index" :label="item.itemName"
                      :value="item.id"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="高度/臂长(米)" align="center">
                <template slot-scope="scope">
                  <el-input-number v-model="scope.row.height" :disabled="formData.dataStatus == 4" :precision="0"
                    style="width: 100%" :controls="false"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="浇筑量(方)" align="center">
                <template slot-scope="scope">
                  <el-input-number v-model="scope.row.num" :disabled="formData.dataStatus == 4" :precision="1"
                    style="width: 100%" :controls="false"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="余料浇筑分配量" align="center">
                <template slot-scope="scope">
                  <el-input-number v-model="scope.row.surplusMaterialsDistribution" :disabled="formData.dataStatus == 4"
                    :precision="1" style="width: 100%" :controls="false"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="卸料时间" align="center" width="220">
                <template slot-scope="scope">
                  <el-date-picker v-model="scope.row.pumpingTime" :disabled="formData.dataStatus == 4" type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择" style="width: 100%"></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column label="泵管使用" align="center" width="220">
                <template slot-scope="scope">
                  <el-radio-group v-model="scope.row.pumpLineUse" :disabled="formData.dataStatus == 4">
                    <el-radio :label="1">内部泵管</el-radio>
                    <el-radio :label="2">外部泵管</el-radio>
                  </el-radio-group>
                </template>
              </el-table-column>
              <el-table-column v-if="formData.dataStatus != 4" label="操作" align="left" prop="specification">
                <template slot-scope="scope">
                  <el-button size="mini" class="bottom_two" @click="deleteDetList(scope.$index)">
                    <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="lookType = false">关 闭</el-button>
        <el-button v-if="formData.dataStatus != 4" class="bottom_all" style="margin-left: 24px"
          @click="update_logisticsFun()">保 存</el-button>
        <el-button class="bottom_all" @click="formdata6Fun(formData, '司机小票')">发送司机</el-button>
        <el-button :disabled="formData.dataStatus != 3 && formData.dataStatus != 2" class="bottom_all"
          @click="formdata6Fun(formData, '客户小票')">发送客户</el-button>
        <el-button class="bottom_all" @click="handlePrint(formData)">打印纸质票</el-button>
      </span>
    </el-dialog>
    <!-- 打印弹窗 -->
    <el-dialog v-dialogDrag :visible.sync="look1Type6" append-to-body width="950px">
      <span slot="title" class="dialog-title">{{ look1Type6Text }}</span>
      <div class="dialoginfo">
        <div>
          <el-card id="dy" shadow="always">
            <div class="top">
              <div>四川华西绿舍建材有限公司</div>
              <div>商品混凝土供货单 <small>No:</small><img :src="formdata6.codeUrl" alt="" /></div>
              <div>
                <span>发货时间：</span>
                <span>流水号：</span>
              </div>
            </div>
            <div class="table">
              <div class="div1">
                <div>
                  <span>项目名称：{{ formdata6.engineeringName }}</span>
                </div>
                <div>
                  <span>签收人：</span>
                </div>
              </div>
              <div class="div1">
                <div>
                  <span>浇筑部位：{{ formdata6.structuralParts }}</span>
                </div>
                <div>
                  <span>砼标号：{{ formdata6.label }}</span>
                </div>
              </div>
              <div class="div2">
                <div>浇筑方式</div>
                <div>{{ formdata6.pouringMethod }}</div>
                <div>本车数量(m3)</div>
                <div>{{ formdata6.faceValue }}</div>
                <div>累计车数</div>
                <div>{{ formdata6.cumulativeTrains }}</div>
              </div>
              <div class="div2">
                <div>车牌号</div>
                <div>{{ formdata6.carNo }}</div>
                <div>发货人</div>
                <div></div>
                <div>进泵时间</div>
                <div></div>
              </div>
              <div class="div2">
                <div>司机</div>
                <div></div>
                <div>泵工签字</div>
                <div></div>
                <div>离泵时间</div>
                <div></div>
              </div>
              <div class="div2">
                <div>高度/臂长</div>
                <div></div>
                <div>搅拌站点</div>
                <div></div>
                <div>小方量运输补差</div>
                <div></div>
              </div>
              <div class="div3">
                <div>备注：</div>
                <div></div>
              </div>
              <div class="div4">
                <div>
                  <i class="el-icon-warning" style="font-size: 30px"></i>
                </div>
                <div>
                  <div>1、请认真复核票面信息，做好交货检验，验收合格后方可签收、浇筑。</div>
                  <div>2、预拌混凝土送到后，严禁加水，请及时浇筑；请按照规范要求组织实验浇筑、振捣、养护、拆模工作。</div>
                  <div>3、请施工单位高度重视上述工作，因上述工作不符合要求而导致的质量问题我司概不负责。</div>
                </div>
              </div>
            </div>
            <div class="bottom">
              <span>服务投诉电话：</span>
              <span>技术服务电话：</span>
              <span>站内调度电话：</span>
            </div>
          </el-card>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        指定打印模板：
        <el-select v-model="printIndex">
          <el-option v-for="(item, index) in printTemplateList" :key="index" :value="item.templateId"
            :label="item.templateName"></el-option>
        </el-select>
        <el-button class="bottom_all_two" @click="look1Type6 = false">关 闭</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="doPrint()">打 印</el-button>
        <el-button v-show="showSend" v-if="look1Type6Text == '司机小票'" :disabled="formdata6.dataStatus != 1"
          class="bottom_all" style="margin-left: 24px" @click="driverReceiptsFun(formdata6)">发 送</el-button>
        <el-button v-show="showSend" v-else :disabled="formdata6.dataStatus != 3 && formdata6.dataStatus != 6"
          class="bottom_all" style="margin-left: 24px" @click="customerFun(formdata6)">发 送</el-button>
      </span>
    </el-dialog>
    <!-- 物流详情 -->
    <el-dialog v-dialogDrag :visible.sync="imgVideoDig" width="750px" :close-on-click-modal="false" append-to-body>
      <span slot="title" class="dialog-title"> 照片/视频</span>
      <div class="dialoginfo j_FZYinfo">
        <el-form ref="imgVideo" :inline="true" :model="low" label-width="150px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="签收人：">
                <span>{{ low.receiver }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="签收时间：">
                <span>{{ low.affirmTime }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="签收小票照片：">
                <span>
                  <el-link v-if="low.driverTicket" class="table_link" :underline="false"
                    @click="handleVideo(low.driverTicket)">查看</el-link>
                  <span v-else>-</span>
                </span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="卸料视频：">
                <span>
                  <el-link v-if="low.videoList && low.videoList.length > 0" class="table_link" :underline="false"
                    @click="look6Fun(low)">查看</el-link>
                  <span v-else>-</span>
                </span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="客户手写签名：">
                <el-link v-if="low.signUrl" class="table_link" :underline="false" @click="signLook(low, 1)">查看</el-link>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="工地重车过磅照片：">
                <span>
                  <el-link v-if="low.reconditionUrl" class="table_link" :underline="false"
                    @click="handleVideo(low.reconditionUrl)">查看</el-link>
                  <span v-else>-</span>
                </span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="工地重车过磅量：">
                <span>{{ low.reconditionSiteNum }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="工地轻车过磅照片：">
                <span>
                  <el-link v-if="low.emptyUrl" class="table_link" :underline="false"
                    @click="handleVideo(low.emptyUrl)">查看</el-link>
                  <span v-else>-</span>
                </span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="工地轻车过磅量：">
                <span>{{ low.emptySiteNum }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="imgVideoDig = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 卸料视频 -->
    <el-dialog v-dialogDrag :visible.sync="look6Type" width="740px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">卸料视频</span>
      <div class="dialoginfo">
        <div class="FZYimgMp4list">
          <div v-if="look6List && look6List.length > 0">
            <video v-for="(item, index) in look6List" :key="index" width="300" height="300"
              style="margin: 5px 10px; box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.35)" :src="'/file/' + item" controls>
              您的浏览器不支持 HTML5 video 标签。
            </video>
          </div>
          <p v-else>暂无卸料视频</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div v-if="list2Info.dataStatus == 4">
          <el-button class="bottom_all_two" @click="look6Type = false">关 闭</el-button>
        </div>
        <div v-else>
          <el-button class="bottom_all_two"
            @click="(look6Type = false), update_data_typeFun(list2Info, 2)">不合格</el-button>
          <el-button class="bottom_all" style="margin-left: 24px" @click="update_data_typeFun(list2Info, 1)">合
            格</el-button>
        </div>
      </span>
    </el-dialog>
    <!-- 签名信息弹窗 -->
    <el-dialog :visible.sync="signDig" width="1280PX" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">{{ signType == 1 ? "客户签名信息" : "后场签名信息" }}</span>
      <div class="dialoginfo">
        <el-row>
          <el-col :span="6" :offset="2">
            <span>工程名称:{{ formTop.engineeringName }}</span>
          </el-col>
          <el-col :span="6" :offset="2">
            <span>产品名称:{{ formTop.productName }}</span>
          </el-col>
          <el-col :span="6" :offset="2">
            <span>浇筑部位:{{ formTop.structuralParts }}</span>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px">
          <el-col :span="6" :offset="2">
            <span>票面量:{{ signLow.faceValue }}</span>
          </el-col>
          <el-col :span="6" :offset="2">
            <span>客户确定余料量:{{ signLow.residueNum }}</span>
          </el-col>
          <el-col :span="6" :offset="2">
            <span>客户确定签收量:{{ signLow.signForNum }}</span>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px">
          <el-col :span="12" :offset="2" style="display: flex">
            <span>{{ signType == 1 ? "客户签名:" : "后场签名:" }}</span>
            <el-image style="width: 100px; height: 100px"
              :src="'https://lvshe.huashijc.com/file' + (signType == 1 ? signLow.signUrl : signLow.chiefSignUrl)"></el-image>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="signDig = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 运输信息 -->
    <transportDetail :visible.sync="transportDetailDig" :config="formData" :type="transportType" :isLook="isLook"
      @reset="get_dispatch_logistics_page"></transportDetail>
    <!-- 查看图片 -->
    <ShowDetails :dialog="imgsDialog" :imgList="imgList" @reset="imgsDialog = false"></ShowDetails>
    <!-- 打印组件 -->
    <Printer ref="printer" :data="formdata6" :firstKey="'concreteCarTicketMain'" :secondKey="'concreteDriverTicket'"
      :stationId="formdata6.templateStationId" :userSelectIndex="printIndex" :printerName="printerName"></Printer>
  </el-dialog>
</template>

<script>
import {
  update_logistics,
  driverReceipts,
  updateTempId,
  printTicket,
  update_confirm_and_data_status,
  notice_customer,
  addOutboundTask,
  addInboundTask,
  update_data_type,
  save_information_collection,
} from "@/api/smart/schedul/j.js";
import {
  queryProduct,
} from "@/api/basicConfig/proflow.js";
import { queryLineByStation, queryLogisticsPage, queryLogisticsPageByAutoTaskId, queryAutoTaskLogisticsPage } from "@/api/smart/productTransport_outside.js";
import { getDicType } from "@/api/common.js";
import Printer from "@/views/components/Printer.vue";
import ShowDetails from "@/components/showdetails";
import transportDetail from "./transportDetail";
import FileComponent from "@/components/File/fileComponent";
export default {
  components: {
    Printer,
    ShowDetails,
    FileComponent,
    transportDetail,
  },
  data() {
    return {
      formTop: {},
      tableB: [
        {
          label: "状态",
          width: "auto",
          prop: "",
          status: true,
        },
        {
          label: "运输号",
          width: "180",
          prop: "code",
          status: true,
        },
        {
          label: "生产时间",
          width: "135",
          prop: "proTime",
          status: true,
        },
        {
          label: "车牌号",
          width: "86",
          prop: "carNo",
          status: true,
        },
        {
          label: "产品名称",
          width: "100",
          prop: "productName",
          status: true,
        },
        {
          label: "票面量",
          width: "auto",
          prop: "faceValue",
          status: true,
        },
        {
          label: "累计方量",
          width: "auto",
          prop: "sumquantity",
          status: true,
        },
        {
          label: "累计车次",
          width: "auto",
          prop: "countcar",
          status: true,
        },
        {
          label: "生产线",
          width: "auto",
          prop: "proLine",
          status: true,
        },
        {
          label: "浇筑方式",
          width: "120",
          prop: "pouringMethodSplit",
          status: true,
        },
        {
          label: "过磅余料量",
          width: "90",
          prop: "residueNum",
          status: true,
        },
        {
          label: "签收量",
          width: "auto",
          prop: "signForNum",
          status: true,
        },
        {
          label: "客户余斜量",
          width: "90",
          prop: "clientResidueNum",
          status: true,
        },
        {
          label: "异常量",
          width: "auto",
          prop: "adjustNum",
          status: true,
        },
        {
          label: "生产站点",
          width: "auto",
          prop: "productionSite",
          status: true,
        },

        {
          label: "容重",
          width: "auto",
          prop: "mixProportion",
          status: true,
        },
        {
          label: "生产量",
          width: "auto",
          prop: "proNum",
          status: true,
        },
        {
          label: "富余量",
          width: "auto",
          prop: "lossNum",
          status: true,
        },
        {
          label: "转入量",
          width: "auto",
          prop: "shiftTo",
          status: true,
        },
        {
          label: "运输数据来源",
          width: "240",
          prop: "",
          status: true,
        },
        {
          label: "照片视频",
          width: "auto",
          prop: "",
          status: true,
        },
        {
          label: "签收",
          width: "70",
          prop: "",
          status: true,
        },
        {
          label: "操作",
          width: "155",
          prop: "",
          status: true,
        },
        {
          label: "打印",
          width: "70",
          prop: "",
          status: true,
        },

        // {
        //   label: "调整余斜量",
        //   width: "auto",
        //   prop: "residueNum",
        //   status: true,
        // },
        // {
        //   label: "调整签收量",
        //   width: "auto",
        //   prop: "signForNum",
        //   status: true,
        // },
        // {
        //   label: "运输距离",
        //   width: "auto",
        //   prop: "transportDistance",
        //   status: true,
        // },
        // {
        //   label: "内部余料",
        //   width: "auto",
        //   prop: "frontIsClout",
        //   status: true,
        // },
        // {
        //   label: "客户余料",
        //   width: "auto",
        //   prop: "companyIsClout",
        //   status: true,
        // },
        // {
        //   label: "客户小方量运输补差(方)",
        //   width: "130",
        //   prop: "",
        //   status: true,
        // },
        // {
        //   label: "运输单位小方量补差(方)",
        //   width: "130",
        //   prop: "",
        //   status: true,
        // },

        // {
        //   label: "高度/臂长(米)",
        //   width: "auto",
        //   prop: "",
        //   status: true,
        // },
        // {
        //   label: "浇筑量(方)",
        //   width: "auto",
        //   prop: "",
        //   status: true,
        // },
        // {
        //   label: "泵送时间",
        //   width: "160",
        //   prop: "",
        //   status: true,
        // },
        // {
        //   label: "泵管使用",
        //   width: "230",
        //   prop: "",
        //   status: true,
        // },

        // {
        //   label: "卸料视频",
        //   width: "auto",
        //   prop: "",
        //   status: true,
        // },
        // {
        //   label: "卸料视频审核状态",
        //   width: "auto",
        //   prop: "",
        //   status: true,
        // },
        // {
        //   label: "运输签收小票",
        //   width: "auto",
        //   prop: "",
        //   status: true,
        // },
        // {
        //   label: "签收类型",
        //   width: "100",
        //   prop: "signType",
        //   status: true,
        // },
        // {
        //   label: "客户手写签名",
        //   width: "100",
        //   prop: "signUrl",
        //   status: true,
        // },
        // {
        //   label: "后场签收时间",
        //   width: "100",
        //   prop: "chiefSignTime",
        //   status: true,
        // },
        // {
        //   label: "后场手写签名",
        //   width: "100",
        //   prop: "chiefSignUrl",
        //   status: true,
        // },
        // {
        //   label: "签收时间",
        //   width: "100",
        //   prop: "affirmTime",
        //   status: true,
        // },
        // {
        //   label: "签收人",
        //   width: "100",
        //   prop: "receiver",
        //   status: true,
        // },
        // {
        //   label: "工地重车过磅照片",
        //   width: "100",
        //   prop: "reconditionUrl",
        //   status: true,
        // },
        // {
        //   label: "工地轻车过磅照片",
        //   width: "100",
        //   prop: "emptyUrl",
        //   status: true,
        // },
        // {
        //   label: "工地重车过磅量",
        //   width: "100",
        //   prop: "reconditionSiteNum",
        //   status: true,
        // },
        // {
        //   label: "工地轻车过磅量",
        //   width: "100",
        //   prop: "emptySiteNum",
        //   status: true,
        // },
        // {
        //   label: "离场类型",
        //   width: "100",
        //   prop: "applyType",
        //   status: true,
        // },
      ],
      tableData: [],
      orderType: "",
      planId: "",
      list1Info: "",
      supplementaryOrdersStatus: 0,
      formData1: {},
      look1Type1: false,
      stationId: "",
      lookType: false,
      formData: {},
      rules1: {
        proTime: [{ required: true, message: "请选择生产时间", trigger: "blur" }],
        proLine: [{ required: true, message: "请选择生产线", trigger: "blur" }],
        carNo: [{ required: true, message: "请输入车牌号", trigger: "blur" }],
        proNum: [{ required: true, message: "请输入生产量(方)", trigger: "blur" }],
        lossNum: [{ required: true, message: "请输入损耗量(方)", trigger: "blur" }],
        shiftTo: [{ required: true, message: "请输入转入量(方)", trigger: "blur" }],
        faceValue: [{ required: true, message: "请输入票面量(方)", trigger: "blur" }],
        adjustNum: [{ required: true, message: "请输入异常调整量(方)", trigger: "blur" }],
        residueNum: [{ required: true, message: "请输入富余量(方)", trigger: "blur" }],
        signForNum: [{ required: true, message: "请输入签收量(方)", trigger: "blur" }],
      },
      pumpTypeList: [],
      formdata6: {},
      look1Type6: false,
      look1Type6Text: "",
      showSend: false,
      printTemplateList: [],
      printIndex: "",
      listFilesa: [],
      siteIdList: [],
      low: {},
      imgVideoDig: false,
      look6Type: false,
      look6List: "",
      list2Info: "",
      signLow: {},
      signType: 1,
      signDig: false,
      imgsDialog: false,
      imgList: [],
      lineList: [],
      transportDetailDig: false,
      transportType: 1,
      printerName: "",
      filterCarNo: "",//筛选车牌号
      productList: [],
      productTime: "",
    };
  },
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
    printSetData: {
      type: Array,
      default: () => ([]),
    },
    carType: {
      type: Number,
      default: 1,
    },
    isLook: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
    },
  },
  filters: {
    imgMp4TypeFun(d) {
      console.log(d.includes("img"));
      if (d.includes("img")) {
        return "img";
      } else {
        return "mp4";
      }
    },
    pouringMethodFilter(e) {
      if (e) {
        e = JSON.parse(e);
        let table = e.map(res => res.name);
        let text = table.join("、");
        return text;
      }
    },
    mixProportionFun(e) {
      if (e) {
        e = JSON.parse(e);
        let table = e.map(res => res.value);
        let text = 0;
        table.forEach(v => {
          text = text + Number(v);
        });
        return text;
      }
    },
  },
  mounted() {
    getDicType({ code: "castingType" }).then(res => {
      res.data.items.map(v1 => (v1.type = 1));
      this.pumpTypeList = res.data.items;
      getDicType({
        code: "pouringMethod",
      }).then(res => {
        res.data.items.map(v2 => (v2.type = 2));
        this.pumpTypeList = [...this.pumpTypeList, ...res.data.items];
      });
    });
  },
  computed: {
    filteredData() {
      if (this.filterCarNo) {
        return this.tableData.filter(item => item.carNo.includes(this.filterCarNo) || item.code.includes(this.filterCarNo));
      } else {
        return this.tableData;
      }
    }
  },
  methods: {
    handleLinkClick() {
    this.supplementaryOrdersStatus = 0;
  },
    gpsMap(row) {
      if (row.gpsFactoryId == '565619044305211392') {
        window.open(`https://lvshe.huashijc.com/h5/#/gpsMap?carNo=${row.carNo}`)
      } else {
        // let parmas = {stationId:row.productionSiteId,carNo:row.carNo}
        // this.$router.push({ name: "smartschedulk", query:parmas });
        // window.open(`http://10.31.0.111:8082/#/map`)
        window.open(`/#/gpsDeviceOut?carNo=${row.carNo}`, "_blank");

      }

    },
    tableRowClassName({ row }) {
      if (row.dataStatus == 8) {
        return "disabled-row";
      }
      return "";
    },
    submit1_1() {
      this.$refs.submit1_1.validate(valid => {
        if (valid) {
          this.formData1.planId = this.planId;
          //   this.formData1.detList = this.arrList1;
          this.formData1.engineeringId = this.formTop.engineeringId;
          this.formData1.engineeringName = this.formTop.engineeringName;
          if (this.listFilesa.length > 0) {
            this.formData1.attachment = this.listFilesa[0].fileName;
            this.formData1.attachmentUrl = this.listFilesa[0].path;
          } else {
            this.formData1.attachment = "";
            this.formData1.attachmentUrl = "";
          }
          save_information_collection(this.formData1).then(res => {
            if (res.code == 1001) {
              this.look1Type1 = false;
              this.onOpen();
            }
          });
        } else {
          return false;
        }
      });
    },
    handleVideo(url) {
      this.imgList = url.split(",").map(res => "/file/" + res);
      this.imgsDialog = true;
    },
    /**外协数据单选 */
    update_data_typeFun(row, videoAudit) {
      let json = {
        id: row.id,
        isProcessing: row.isProcessing,
        isCarriage: row.isCarriage,
        isPumping: row.isPumping,
      };
      if (videoAudit) {
        json.videoAudit = videoAudit;
      }
      update_data_type(json).then(res => {
        if (res.code == 1001) {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.look6Type = false;
          this.onOpen();
        }
      });
    },
    //1客户签名,2后场签名
    signLook(row, type) {
      this.signLow = row;
      this.signType = type;
      this.signDig = true;
    },
    /**卸料视频 */
    look6Fun(row) {
      this.look6List = row.videoList;
      this.look6Type = true;
      this.list2Info = row;
    },
    imgVideo(row) {
      this.low = row;
      this.imgVideoDig = true;
    },
    addOutboundTask(code, index) {
      let _this = this;
      addOutboundTask({ logisticsCode: code, supplementaryOrdersStatus: this.supplementaryOrdersStatus }).then(res => {
        if (res.code == 1001) {
          this.$message.success("操作成功!");
          _this.$refs[`popover1-${index}`][0].doClose();
          _this.$refs[`popover1-${index}`][1].doClose();
        }
      });
    },
    addInboundTask(code, index) {
      let _this = this;
      addInboundTask({ logisticsCode: code, supplementaryOrdersStatus: this.supplementaryOrdersStatus }).then(res => {
        if (res.code == 1001) {
          this.$message.success("操作成功!");
          _this.$refs[`popover2-${index}`][0].doClose();
          _this.$refs[`popover2-${index}`][1].doClose();
        }
      });
    },
    /**
     * @Description: 删除附件
     * @Param:
     * @Author: wangwangwang
     */
    deleteFile(index) {
      this.listFilesa.splice(index, 1);
    },
    /**
     * @Description: 上传成功
     * @Param:
     * @Author: wangwangwang
     */
    uplodeSuccess(data) {
      this.listFilesa = [];
      let item = {
        name: data.fileName,
        fileName: data.fileName,
        path: data.fileUrl,
      };
      this.listFilesa.push(item);
    },
    getPrintTemplate(list) {
      this.printTemplateList = list;

      //整理conditionList和模板id
      let conditionDes = [];
      let conditionObj = {};
      list.forEach(item => {
        const data = item;
        conditionObj.stationTemplateId = item.stationTemplateId;
        console.log(data.conditionList);
        if (item.conditionList && item.conditionList.length !== 0) {
          item.conditionList.forEach(ite => {
            conditionObj[ite.conditionName] = ite.conditionData;
          });
        }
        conditionDes.push(conditionObj);
      });
      //对比conditionDes和this.formData
      let checkSame = condition => {
        let a = condition.find(item => {
          //不考虑["stationTemplateId","brand","originPlace","transportUnit"]这些属性是否相同
          let a = Object.keys(item).filter(item => !["stationTemplateId", "brand", "originPlace", "transportUnit"].find(ite => item == ite));
          //判断剩下的属性值是否和low的相同
          let sameLength = 0;
          a.forEach(ite => {
            if (ite == "isFirstSupply") {
              let isFirstSupply = this.formData[ite] == 1 ? "Y" : "N";
              if (item[ite] === isFirstSupply) {
                sameLength++;
              }
            } else {
              if (item[ite] === this.formData[ite]) {
                sameLength++;
              }
            }
          });
          //找出low和condition属性全部相同的哪个对象并返回id
          return sameLength == a.length;
        });
        if (a == undefined) {
          return 0;
        }
        return a.stationTemplateId;
      };
      if (!this.printIndex) {
        if (checkSame(conditionDes) != 0) {
          let marryTemplate = list.find(item => item.stationTemplateId == checkSame(conditionDes));
          this.printIndex = marryTemplate.templateId;
        } else {
          this.printIndex = list[0].templateId;
        }
      }
    },
    /**司机小票发送 */
    driverReceiptsFun() {
      update_confirm_and_data_status({
        id: this.formdata6.id,
        dataStatus: 2,
      }).then(res => {
        if (res.code == 1001) {
          this.$message({
            type: "success",
            message: "发送成功!",
          });
          this.look1Type6 = false;
          this.onOpen();
        }
      });
    },
    customerFun(e) {
      let json = {
        id: e.id, // 物流信息主键id
        planId: this.planId, // 订单id
        engineeringName: e.engineeringName, // 工程名
        orderNo: e.orderNo, // 订单号
        productName: e.productName, // 产品名
        adjustResidueNum: e.adjustResidueNum, //调整余料量
        adjustSignForNum: e.adjustSignForNum, //调整签收量
        code: e.code, // 运输号
        carNo: e.carNo, // 车牌号
        proTime: e.proTime, // 生产时间
        proNum: e.proNum, // 生产量
        lossNum: e.lossNum, // 损耗量
        shiftTo: e.shiftTo, // 转入量
        faceValue: e.faceValue, // 票面量
        adjustNum: e.adjustNum, // 异常调整量
      };
      notice_customer(json).then(res => {
        if (res.code == 1001) {
          this.$message({
            type: "success",
            message: "发送成功!",
          });
          this.onOpen();
        }
      });
    },
    /**打印*/
    doPrint() {
      updateTempId({ id: this.formData.id, templateId: this.printIndex }).then(res => {
        if (res.code === 1001) {
          this.handlePrint(this.formData);
        }
      });
      printTicket({ proCode: this.formData.code });
      this.$refs["printer"].print();
    },
    handlePrint(e) {
      let _this = this;
      // this.look1Type6 = true;
      this.formdata6 = e;
      // this.look1Type6Text = "司机小票";
      // this.showSend = false;
      driverReceipts({ code: e.code }).then(res => {
        if (res.code == 1001) {
          _this.formdata6 = res.data;
          _this.printIndex = res.data.templateId;
          console.log('-------1----', _this.printIndex)
          _this.formdata6.codeUrl = "file/" + this.formdata6.codeUrl;
          this.printerName = "";
          let lineItem = this.printSetData.find(item => item.name == _this.formdata6.productionLine);
          this.printerName = lineItem.printerName;
          this.$refs["printer"].print(_this.printIndex, _this.formdata6);
        }
      });
    },
    /**运输信息 */
    addDetList() {
      this.formData.detList.push({
        pouringWayId: "", //浇筑方式id
        pouringWay: "", //浇筑方式
        pumpWay: "", //泵送方式，1是，0非
        num: "", //方量
        surplusMaterialsDistribution: "",
        height: "", //臂长
        createTime: "", //浇筑时间
        pumpLineUse: 1, //泵管使用：1内部泵管，2外部泵管
        logisticsNo: this.formData.id,
      });
      let length = Number(this.formData.detList.filter(item => item.status != 0).length);
      let numSum = 0;
      let surplusMaterialsDistributionSum = 0;
      console.log(this.formData.detList);
      console.log(this.formData.detList.filter(item => item.status != 0));
      this.formData.detList.forEach((item, index) => {
        if (item.status != 0) {
          if (index != this.formData.detList.length - 1) {
            item.num = Number(Number(this.formData.signForNum) / length).toFixed(1);
            numSum = Number(numSum) + Number(item.num);
            item.surplusMaterialsDistribution = Number(Number(this.formData.residueNum) / length).toFixed(1);
            surplusMaterialsDistributionSum = Number(surplusMaterialsDistributionSum) + Number(item.surplusMaterialsDistribution);
          } else {
            item.num = this.formData.signForNum - numSum;
            item.surplusMaterialsDistribution = this.formData.residueNum - surplusMaterialsDistributionSum;
          }
        }
      });
    },
    deleteDetList(index) {
      if (this.formData.detList[index].id) {
        this.formData.detList[index].status = 0;
      } else {
        this.formData.detList.splice(index, 1);
      }
    },
    formdata6Fun(e, name) {
      this.look1Type6 = true;
      this.formdata6 = e;
      this.look1Type6Text = name;
      this.showSend = true;
      driverReceipts({ code: e.code }).then(res => {
        if (res.code == 1001) {
          this.formdata6 = res.data;
          this.formdata6.codeUrl = "file/" + this.formdata6.codeUrl;
        }
      });
    },
    update_logisticsFun() {
      update_logistics(this.formData).then(res => {
        if (res.code == 1001) {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.lookType = false;
          this.onOpen();
        }
      });
    },
    changeItem2(e) {
      let item = this.pumpTypeList.find(v => v.id == e.pouringWayId);
      e.pouringWay = item.itemName;
      if (item.type == 1) {
        e.pumpWay = 1;
      } else {
        e.pumpWay = 0;
      }
    },
    lookFun(e, type) {
      // this.lookType = true;
      this.transportType = type;
      this.transportDetailDig = true;
      this.formData = e;
      // this.$refs["formDataTable"]?.doLayout();
    },
    look1Type1Fun() {
      this.formData1 = {};
      queryProduct({ stationId: this.formTop.stationId }).then(res => {
        if (res.code == 1001) {
          this.productList = res.data
        }
      })
      this.formData1.productionSite = this.formTop.stationName;
      this.formData1.productionSiteId = this.formTop.stationId;
      this.formData1.chiefSignUrl = this.config.id;
      if(this.carType == 2) {
        this.formData1.productName = this.formTop.productName || this.formTop.product
      }
      
      this.look1Type1 = true;
      setTimeout(() => {
        this.$refs.submit1_1.clearValidate();
      }, 100);
    },
    async onOpen() {
      console.log(this.config);
      if (this.config) {
        this.orderType = this.config.orderType;
        this.formTop = this.config;
        this.planId = this.config.planId;
        this.list1Info = this.config;
        this.stationId = this.config.stationId;
      }
      this.productTime = new Date().Format("yyyy-MM-dd 00:00:00")
      this.get_dispatch_logistics_page();
      //获取生产线
      queryLineByStation({ stationId: this.stationId }).then(res => {
        if (res.code == 1001) {
          this.lineList = res.data;
        }
      });
    },
    get_dispatch_logistics_page() {
      let obj
      let logisticMethod;
      switch (this.carType) {
        case 1:
          logisticMethod = queryLogisticsPage;
          obj = {
            planId: this.planId,
            page: 1,
            pageSize: 1000,
          };
          break;
        case 2:
          logisticMethod = queryLogisticsPageByAutoTaskId;
          obj = {
            id: this.config.id,
            page: 1,
            pageSize: 1000,
          };
          break;
        case 3:
          logisticMethod = queryAutoTaskLogisticsPage;
          obj = {
            stationId: this.stationId,
            page: 1,
            pageSize: 1000,
            createTime: this.productTime || '',
          };
          break;
      }
      logisticMethod(obj).then(res => {
        if (res.code === 1001) {
          this.tableData = res.data.data;
        }
      });
    },
    className({ row }) {
      if (row.status == 0) {
        return "tableHidden";
      }
    },
    onClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>
<style lang="scss" scoped>
.table_link {
  margin: 0 10px;
  color: $bg_color;
}

.table_link:hover {
  opacity: 0.8;
}

.tableHidden {
  display: none;
}

#dy {
  padding: 15px;

  .el-card__body {
    border: 1px solid #ccc;
    padding: 35px;

    .top {
      >div:nth-of-type(1) {
        font-size: 26px;
        font-weight: 600;
        text-align: center;
      }

      >div:nth-of-type(2) {
        padding-top: 10px;
        font-size: 18px;
        font-weight: 600;
        text-align: center;
        position: relative;

        >small {
          position: absolute;
          left: 535px;
          top: 15px;
          font-weight: 100;
          font-size: 14px;
        }

        >img {
          width: 80px;
          position: absolute;
          right: 0px;
          top: -25px;
        }
      }

      >div:nth-of-type(3) {
        padding: 5px 0 5px 0;

        >span {
          font-size: 14px;
          width: 350px;
          display: inline-block;
        }
      }
    }

    .table {
      border: 1px solid #ccc;

      .div1 {
        display: flex;
        min-height: 55px;

        >div:nth-of-type(1) {
          width: 490px;
          flex: none;
          border-right: 1px solid #ccc;
          border-bottom: 1px solid #ccc;
          padding: 17px 5px;
        }

        >div:nth-of-type(2) {
          flex: 1;
          border-bottom: 1px solid #ccc;
          padding: 17px 5px;
        }
      }

      .div2 {
        font-size: 13px;
        display: flex;
        min-height: 30px;

        >div:nth-child(odd) {
          width: 110px;
          flex: none;
          border-right: 1px solid #ccc;
          border-bottom: 1px solid #ccc;
          padding: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        >div:nth-child(even) {
          width: 165px;
          flex: none;
          border-right: 1px solid #ccc;
          border-bottom: 1px solid #ccc;
          padding: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        >div:nth-of-type(4) {
          width: 105px;
          flex: none;
        }
      }

      .div3 {
        font-size: 13px;
        min-height: 30px;
        display: flex;

        >div:nth-of-type(1) {
          width: 110px;
          flex: none;
          border-right: 1px solid #ccc;
          border-bottom: 1px solid #ccc;
          padding: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        >div:nth-of-type(2) {
          flex: 1;
          border-bottom: 1px solid #ccc;
          padding: 5px;
          display: flex;
          align-items: center;
        }
      }

      .div4 {
        font-size: 13px;
        min-height: 30px;
        display: flex;

        >div:nth-of-type(1) {
          width: 110px;
          flex: none;
          border-right: 1px solid #ccc;
          border-bottom: 1px solid #ccc;
          padding: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        >div:nth-of-type(2) {
          flex: 1;
          border-bottom: 1px solid #ccc;
          padding: 5px;
        }
      }
    }

    .bottom {
      margin: 10px 10px;

      >span {
        display: inline-block;
        width: 245px;
      }
    }
  }
}

#dyBox {
  display: none;
  width: 1000px;
  font-size: 22px;

  .qrcode-container {
    text-align: right;
    padding: 20px 120px 45px 0;

    .qrcode {
      width: 90px;
      height: 90px;
    }
  }
}

.ellipsis-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
<style scoped>
.carDetail>>>.disabled-row {
  background: #c1c1c1;
  opacity: 0.6;
}
</style>